module.exports = __webpack_public_path__ + "media/images/bg-gold-8ffc506eaa407dc79d5b866952d9272a.jpg";